import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
	const navigate = useNavigate();

	const handleGoHome = () => {
		navigate("/dashboard");
	};

	const handleGoBack = () => {
		navigate(-1);
	};

	return (
		<div className="min-h-screen bg-background flex items-center justify-center p-4">
			<Card className="w-full max-w-md">
				<CardContent className="pt-6">
					<div className="text-center space-y-6">
						{/* Large 404 */}
						<div className="text-8xl font-bold text-muted-foreground/30">404</div>

						{/* Vietnamese error message */}
						<div className="space-y-2">
							<h1 className="text-2xl font-semibold text-foreground">Không tìm thấy trang</h1>
							<p className="text-muted-foreground">
								Trang bạn đang tìm kiếm không tồn tại hoặc đã bị di chuyển.
							</p>
						</div>

						{/* Action buttons */}
						<div className="flex flex-col sm:flex-row gap-3 pt-4">
							<Button onClick={handleGoBack} variant="outline" className="flex items-center gap-2">
								<ArrowLeft className="h-4 w-4" />
								Quay lại
							</Button>
							<Button onClick={handleGoHome} className="flex items-center gap-2">
								<Home className="h-4 w-4" />
								Về trang chủ
							</Button>
						</div>
					</div>
				</CardContent>
			</Card>
		</div>
	);
}
